import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MG',
  name: 'Mariana G.',
  location: 'Córdoba',
  role: 'Maestra integradora',
  highlight: 'Ahorra horas de armado',
  content: 'Antes perdía horas armando actividades para distintos niveles. Ahora abro el pack y ya tengo todo listo para trabajar.',
  color: '#FFB5C5' // Pink
}, {
  initials: 'LR',
  name: 'Lucía R.',
  location: 'Buenos Aires',
  role: 'Mamá de un niño con TEA',
  highlight: 'Conecta mejor en casa',
  content: 'Mi hijo conecta muchísimo mejor con los pictogramas y juegos visuales. Nos cambió completamente la rutina en casa.',
  color: '#A8E6CF' // Mint
}, {
  initials: 'CP',
  name: 'Carolina P.',
  location: 'Rosario',
  role: 'Docente de primaria',
  highlight: 'Alumnos motivados',
  content: 'Los cuadernos de atención y lectoescritura son increíbles. Mis alumnos están mucho más motivados.',
  color: '#B5D8F5' // Baby Blue
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#F5EEF8] py-16 sm:py-24 px-4" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        <div className="text-center mb-12 sm:mb-16" data-id="element-229">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#3D3935] mb-4 max-w-3xl mx-auto" data-id="element-230">
            Lo que dicen los docentes y familias que ya lo usan
          </h2>
          <div className="flex items-center justify-center gap-1 text-[#F5C84B] text-xl" data-id="element-231">
            ⭐⭐⭐⭐⭐
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-232">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-[#EFE3D4] relative" data-id="element-233">
              {/* Quote mark */}
              <div className="absolute top-6 right-6 text-4xl text-[#EFE3D4] font-serif leading-none" data-id="element-234">
                "
              </div>

              <div className="flex items-center gap-4 mb-6" data-id="element-235">
                <div className="w-12 h-12 rounded-full flex items-center justify-center text-[#3D3935] font-black text-lg shadow-sm" style={{
              backgroundColor: testimonial.color
            }} data-id="element-236">
                  {testimonial.initials}
                </div>
                <div data-id="element-237">
                  <h4 className="text-[#3D3935] font-black text-base leading-tight" data-id="element-238">
                    {testimonial.name}
                  </h4>
                  <p className="text-[#8B7E76] text-xs font-bold" data-id="element-239">
                    {testimonial.role} · {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="mb-4" data-id="element-240">
                <span className="inline-block bg-[#FFF8F0] text-[#F5A04B] text-xs font-black px-2.5 py-1 rounded-md border border-[#EFE3D4]" data-id="element-241">
                  ✨ {testimonial.highlight}
                </span>
              </div>

              <p className="text-[#3D3935] font-medium text-sm sm:text-base leading-relaxed italic" data-id="element-242">
                "{testimonial.content}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}